import { Navigate } from 'react-router-dom';
import { useAuth } from '@/shared/auth/AuthContext';
import { isMasterEmail } from '@/shared/firebase/admin';
import type { AccessCodeRole } from '@/shared/firebase/codes';
import type { ReactNode } from 'react';

type Props = {
  expected: AccessCodeRole | 'admin';
  children: ReactNode;
};

export function RoleGuard({ expected, children }: Props) {
  const { user, accessCode, loading } = useAuth();

  if (loading) {
    return <div className="min-h-full grid place-items-center text-slate-500 text-sm">Cargando…</div>;
  }

  if (expected === 'admin') {
    if (isMasterEmail(user?.email)) return <>{children}</>;
    return <Navigate to="/login" replace state={{ from: '/admin' }} />;
  }

  if (accessCode) {
    if (accessCode.role !== expected) {
      return <Navigate to={`/${accessCode.role}`} replace />;
    }
    return <>{children}</>;
  }

  // Admin con email puede ver cualquier panel
  if (isMasterEmail(user?.email)) return <>{children}</>;

  // No autenticado
  return <Navigate to="/login" replace state={{ from: `/${expected}` }} />;
}
